import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BeaconPositionEvent } from "../../../api/models";
import { BaseDrawer } from "../../BaseDrawer";
import { Chart, SeriesDefinition } from "../../chart/Chart";
import { DownloadPositions } from "../../DownloadPositions";

interface SCBOneLocationDrawerProps {
  isLoading: boolean;
  operationRunSelected: boolean;
  positionSeriesDefinition: SeriesDefinition[];
  locationDrawerVisible: boolean;
  onCloseDrawer: (visible: boolean) => void;
}

export function SCBOneLocationDrawer({
  isLoading,
  operationRunSelected,
  positionSeriesDefinition,
  locationDrawerVisible,
  onCloseDrawer,
}: SCBOneLocationDrawerProps) {
  const { t } = useTranslation();
  const [renderChart, setRenderChart] = useState(false);

  return (
    <BaseDrawer
      title={t("beacon:position-data")}
      drawerVisible={locationDrawerVisible}
      onCloseDrawer={() => onCloseDrawer(false)}
      afterOpenChange={(open) => setRenderChart(open)}
    >
      {renderChart && (
        <Chart
          seriesDefintions={positionSeriesDefinition}
          alertMessage={
            operationRunSelected
              ? t("scb-one:run-notification-no-data")
              : t("scb-one:run-notification-select")
          }
          isLoading={isLoading}
        />
      )}
    </BaseDrawer>
  );
}

interface BeaconLocationDrawerProps {
  beaconId: string;
  positions: BeaconPositionEvent[];
  positionHistoryIsLoading: boolean;
  positionSeriesDefinition: SeriesDefinition[];
  locationDrawerVisible: boolean;
  positionFromToDateRange: {
    from: Date;
    to: Date;
  };
  onCloseDrawer: (visible: boolean) => void;
}

export function BeaconLocationDrawer({
  beaconId,
  positions,
  positionHistoryIsLoading,
  positionSeriesDefinition,
  locationDrawerVisible,
  positionFromToDateRange,
  onCloseDrawer,
}: BeaconLocationDrawerProps) {
  const { t } = useTranslation();
  const [renderChart, setRenderChart] = useState(false);

  return (
    <BaseDrawer
      title={t("beacon:position-data")}
      drawerVisible={locationDrawerVisible}
      onCloseDrawer={() => onCloseDrawer(false)}
      afterOpenChange={(open) => setRenderChart(open)}
    >
      {renderChart && (
        <Chart
          seriesDefintions={positionSeriesDefinition}
          isLoading={positionHistoryIsLoading}
        />
      )}
      {!!positions?.length && (
        <DownloadPositions
          beaconId={beaconId}
          positions={positions}
          style={{ position: "absolute", bottom: 10, right: 40 }}
          from={positionFromToDateRange.from}
          to={positionFromToDateRange.to}
        />
      )}
    </BaseDrawer>
  );
}
